<div class="w-full h-full flex justify-center">

    <div class="w-full">

        <div class="w-full flex flex-col gap-8">
            <div class="w-full flex flex-row md:justify-end items-center gap-5">
                <!-- Title & Subtitle -->
                <div class="w-full flex flex-col gap-[5px]" [ngClass]="{'hidden': !breakpoint.md.value}">
                    <div class="flex items-center gap-1">
                        <p class="text-[22px] font-semibold" i18n>
                            Organisaties
                        </p>
                    </div>
                    <p class="text-[16px] text-app-global-text-secondary" i18n>Organisaties in de hele applicatie
                    </p>
                </div>

                <div class="flex flex-col-reverse justify-end xs:flex-row w-full gap-3 md:gap-5">
                    <!-- Search -->
                    <mat-form-field class="w-full md:max-w-60 search">
                        <input matInput i18n-placeholder placeholder="Zoeken..." [formControl]="searchControl">
                    </mat-form-field>

                    <!-- New organization -->
                    <button mat-flat-button color="primary" class="shrink-0" routerLink="/settings/organizations/new">
                        <span *ngIf="breakpoint.lg.value && !breakpoint.xl.value" i18n>
                            Nieuw
                        </span>
                        <span *ngIf="!(breakpoint.lg.value && !breakpoint.xl.value)" i18n>
                            Nieuwe organisatie
                        </span>
                    </button>
                </div>
            </div>


            <!-- Organizations table -->
            <app-table [settings]="organizationTableSettings" #table>
                <!-- Name -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef i18n> Naam </th>
                    <td mat-cell *matCellDef="let organization">
                        <p>{{organization.name}}</p>
                    </td>
                </ng-container>

                <!-- Language -->
                <ng-container matColumnDef="language">
                    <th mat-header-cell *matHeaderCellDef i18n [ngClass]="{'hidden': !breakpoint.xl.value}"> Taal </th>
                    <td mat-cell *matCellDef="let organization" [ngClass]="{'hidden': !breakpoint.xl.value}">
                        <p *ngIf="organization.language === 'nl'" i18n>Nederlands</p>
                        <p *ngIf="organization.language === 'en'" i18n>Engels</p>
                    </td>
                </ng-container>

                <!-- Users -->
                <ng-container matColumnDef="users">
                    <th mat-header-cell *matHeaderCellDef i18n [ngClass]="{'hidden': !breakpoint.sm.value}"> Gebruikers
                    </th>
                    <td mat-cell *matCellDef="let organization" [ngClass]="{'hidden': !breakpoint.sm.value}">
                        <div class="flex items-center gap-1">
                            <mat-icon svgIcon="users" class="scale-75 text-app-global-text-primary"></mat-icon>
                            <p>{{organization.Users_aggregate.aggregate.count}}</p>
                        </div>
                    </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef i18n class="w-[130px]"></th>
                    <td mat-cell *matCellDef="let organization">
                        <div class="flex items-center justify-end w-full gap-5">
                            <!-- Switch organization button -->
                            <button mat-stroked-button
                                *ngIf="organization.id !== organizationService.currentOrganization$.value?.id"
                                (click)="$event.stopPropagation(); switchOrganization(organization, table)"
                                class="w-[90px] h-[36px]" i18n>
                                Wisselen
                            </button>
                            <p class="text-app-global-text-secondary text-base font-semibold w-[90px] text-center"
                                *ngIf="organization.id === organizationService.currentOrganization$.value?.id" i18n>
                                Actief
                            </p>
                            <!-- Edit -->
                            <button mat-button i18n class="text-app-global-primary">
                                <mat-icon svgIcon="pencil"></mat-icon>
                                Bewerken
                            </button>
                            <!-- Edit -->
                            <button mat-button i18n class="text-app-global-primary" (click)="$event.stopPropagation()"
                                [routerLink]="['/settings/organizations/config', organization.id]">
                                <mat-icon svgIcon="sliders-horizontal"></mat-icon>
                                Configuratie
                            </button>
                        </div>
                    </td>
                </ng-container>
            </app-table>
        </div>
    </div>
</div>